<template>
  <div class="smart-venues">
    <HeaderStyles1>
<!--      <h1 slot="title" v-html="$t('smart-venues-head-h1')"></h1>-->
<!--      <p slot="detail" v-html="$t('smart-venues-head-small')"></p>-->
<!--      <b-img class="platform-title-img" slot="image" src="../assets/imgs/head-img-smart-venues.png" alt="" />-->
    </HeaderStyles1>

    <b-container fluid="xl" class="main-content">
<!--      <section class="page-section">-->
<!--        <h1 class="section-title">{{$t('smart-venues-section-1-title')}}</h1>-->
<!--        <b-row class="mt-5">-->
<!--          <b-col class="text-center">-->
<!--            <h3 class="section-1-title">{{$t('smart-venues-section-1-title-1')}}</h3>-->
<!--            <div class="arrow-top-wrap"><i class="arrow-top"></i></div>-->
<!--          </b-col>-->
<!--          <b-col class="text-center">-->
<!--            <h3 class="section-1-title">{{$t('smart-venues-section-1-title-2')}}</h3>-->
<!--            <div class="arrow-top-wrap"><i class="arrow-top"></i></div>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--        <b-row class="section-1-content" cols="11">-->
<!--          <b-col cols="2" class="section-1-item">-->
<!--            <b-img fluid src="../assets/imgs/section-1-icon-1.png" />-->
<!--            <span>{{$t('smart-venues-section-1-item-1-text')}}</span>-->
<!--          </b-col>-->
<!--          <b-col cols="1" class="section-1-arrow">-->
<!--            <b-img fluid src="../assets/imgs/section-1-arrow.png" />-->
<!--            <span>{{$t('smart-venues-section-1-arrow-1-text')}}</span>-->
<!--          </b-col>-->

<!--          <b-col cols="2" class="section-1-item">-->
<!--            <b-img fluid src="../assets/imgs/section-1-icon-2.png" />-->
<!--            <span>{{$t('smart-venues-section-1-item-2-text')}}</span>-->
<!--          </b-col>-->
<!--          <b-col cols="1" class="section-1-arrow">-->
<!--            <b-img fluid src="../assets/imgs/section-1-arrow.png" />-->
<!--            <span>{{$t('smart-venues-section-1-arrow-2-text')}}</span>-->
<!--          </b-col>-->

<!--          <b-col cols="2" class="section-1-item">-->
<!--            <b-img fluid src="../assets/imgs/section-1-icon-3.png" />-->
<!--            <span>{{$t('smart-venues-section-1-item-3-text')}}</span>-->
<!--          </b-col>-->
<!--          <b-col cols="1" class="section-1-arrow">-->
<!--            <b-img fluid src="../assets/imgs/section-1-arrow.png" />-->
<!--            <span>{{$t('smart-venues-section-1-arrow-3-text')}}</span>-->
<!--          </b-col>-->

<!--          <b-col cols="2" class="section-1-item">-->
<!--            <b-img fluid src="../assets/imgs/section-1-icon-4.png" />-->
<!--            <span>{{$t('smart-venues-section-1-item-4-text')}}</span>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--      </section>-->

<!--      <section class="page-section">-->
<!--        <h1 class="section-title">{{$t('smart-venues-section-2-title')}}</h1>-->
<!--        <b-row class="mt-5">-->
<!--          <b-col sm="6" md="5" xl="5">-->
<!--            <p class="section-2-text" v-html="$t('smart-venues-section-2-content')"></p>-->
<!--          </b-col>-->
<!--          <b-col sm="6" md="7" xl="7">-->
<!--            <b-img fluid-grow src="../assets/imgs/section-2-image.png"></b-img>-->
<!--          </b-col>-->
<!--        </b-row>-->
<!--      </section>-->
      <section class="page-section">
        <h1 class="section-title">天天走路（多多运动计步器）</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_duoduop_des_1.png"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_duoduop_des_2.png"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_duoduop_des_3.png"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    天天走路（多多运动计步器），主要功能模块有：健步，徒步，活动，早起。
                    <br/>
                    天天走路（多多运动计步器）功能:
                    <br/>
                    【精准简约计步，计算卡路里消耗】精准的计步算法，通过高灵敏的重力传感器精准计算，实时计步，坚持运动领取运动勋章，可通过全国和区域运动排行PK运动量。
                    <br/>
                    【趣味跑步，骑行】趣味跑步，各种路线等你挑战，领取跑步，骑行，路线勋章。
                    <br/>
                    【精选健身课程】精选健身课程，运动前后拉伸，减肥瘦身各种精选健身课程。
                    <br/>
                    【健步团】跟好友一起运动，找个运动伴。
                    <br/>
                    【趣味活动】重走长征，公里挑战等你来
                    <br/>
                    【早起打卡，喝水提醒】每天坚持早起打卡，每天一杯水，新一天从早起开始。
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">木鱼多多</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/muyu_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/muyu_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/muyu_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/muyu_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    木鱼多多，敲木鱼定神，念佛珠静心
                    <br/>
                    木鱼多多功能:
                    <br/>
                    【敲木鱼】按节律敲打木鱼，用于定神,可设置自动，背景禅音
                    <br/>
                    【念佛珠】按节律念佛珠，用于静心,可设置自动，背景禅音
                    <br/>
                    【经文】查看阅读经文
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">攒米盒子</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/box_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/box_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/box_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/box_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    攒米盒子，一款简约兼职工具
                    <br/>
                    攒米盒子功能:
                    <br/>
                    【游戏赚】玩游戏赚
                    <br/>
                    【搜索赚】搜索任务赚
                    <br/>
                    【提现】快速提现
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">猜歌趣多多</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/song_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/song_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/song_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/song_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    猜歌挑战，听歌曲某个片段猜歌名。
                    <br/>
                    猜歌趣多多功能:
                    <br/>
                    【猜歌挑战】听歌曲某个片段猜歌名
                    <br/>
                    【助眠解压】精选助眠解压音乐，助您好睡眠
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">朝夕天气</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/weather_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/weather_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/weather_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/weather_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    【智能语音播报】智能语音播报当日天气状况，根据生活指数，提供穿衣建议，出行建议；
                    <br/>
                    【精准未来预报】精准15天预报，灵活应对未知天气；
                    <br/>
                    【城市管理】可切换多个城市，预览对比多个城市天气；
                    <br/>
                    【万年黄历】万年黄历，查看宜忌；
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">答题多多</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_question_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_question_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_question_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_question_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    答的越多懂的越多，主要功能模块有：查询题目、题库测试和练习，错题练习，收藏题目练习，考试记录等功能。
                    <br/>
                    答题多多功能:
                    <br/>
                    【查询题目】模糊快速查询题目
                    <br/>
                    【题库考试】模拟测试各大经典考试
                    <br/>
                    【错题练习】记录错题，从容应对
                    <br/>
                    【收藏题目】收藏题目，加深影响
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>

      <section class="page-section">
        <h1 class="section-title">朝夕清理</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_cooler_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_cooler_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_cooler_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_cooler_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>cpu温度监控散热器，专业手机温度监控和降温软件，通过检测并关闭发热应用，减少CPU能耗，彻底解决手机发热问题。
                    <br/>
                    实时监控手机温度，实时检测并记录手机温度变化情况，并为您实时呈现手机温度变化曲线图。
                    <br/>
                    动态检测发热应用，动态分析CPU使用情况，检测大量占用CPU资源的应用，找出导致手机发热的元凶。
                    <br/>
                    一键关闭发热应用，降低CPU能耗，让手机恢复正常温度。关闭可能导致手机发热的应用，避免手机温度升高。</h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>

      <section class="page-section">
        <h1 class="section-title">清理加速器多多</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_a_1.png"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_a_2.png"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_a_3.png"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_a_4.png"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    手机一键真降温，超强极速的空间清理加速神器！
                    <br/>
                    用更少的时间，安全彻底删除更多无用的文件，致力于为用户提供更安全更快捷的清理体验！
                    <br/>
                    一手机降温一
                    <br/>
                    【电池省电】一键智能省电，智能监测手机温度，电量，电压，健康状态动态监测
                    <br/>
                    【CPU降温】一键真降温，不再为手机发烫烦恼，手机的降温管家
                    <br/>
                    一极速清理一
                    <br/>
                    【一键清理】一键搞定无用垃圾，手机清理更省心
                    <br/>
                    【深度清理】全盘扫描手机储存空间，深度清理垃圾
                    <br/>
                    【手机加速】瞬间释放手机内存，加速效果超同行
                    <br/>
                    【抖音|QQ|微信清理】有效清理抖音，微信，qq的无用垃圾文件，让手机运行更顺畅
                    <br/>
                    一手机管理一
                    <br/>
                    【通知清理】告别无用的推送通知！
                    <br/>
                    【最近文件】视频、照片、音频、安装包等文件一键管理，智能识别可删文件</h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">{{$t('smart-venues-section-3-title')}}</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="4" xl="4" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/bg_jibu.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="8" xl="8">
              <b-row>
                <b-col cols="6" class="section-list-item">
                  <img class="section-list-item-img" src="../assets/imgs/icon_jibu.png" alt="" />
                  <div class="section-list-item-content">
                    <h4>{{$t('smart-venues-section-3-item-1-title')}}</h4>
                    <p>{{$t('smart-venues-section-3-item-1-content')}}</p>
                  </div>
                </b-col>

                <b-col cols="6" class="section-list-item">
                  <img class="section-list-item-img" src="../assets/imgs/icon-locate-target.png" alt="" />
                  <div class="section-list-item-content">
                    <h4>{{$t('smart-venues-section-3-item-2-title')}}</h4>
                    <p>{{$t('smart-venues-section-3-item-2-content')}}</p>
                  </div>
                </b-col>

                <b-col cols="6" class="section-list-item">
                  <img class="section-list-item-img" src="../assets/imgs/icon_tianqiyubao.png" alt="" />
                  <div class="section-list-item-content">
                    <h4>{{$t('smart-venues-section-3-item-3-title')}}</h4>
                    <p>{{$t('smart-venues-section-3-item-3-content')}}</p>
                  </div>
                </b-col>

                <b-col cols="6" class="section-list-item">
                  <img class="section-list-item-img" src="../assets/imgs/icon_health.png" alt="" />
                  <div class="section-list-item-content">
                    <h4>{{$t('smart-venues-section-3-item-4-title')}}</h4>
                    <p>{{$t('smart-venues-section-3-item-4-content')}}</p>
                  </div>
                </b-col>

                <b-col cols="6" class="section-list-item">
                  <img class="section-list-item-img" src="../assets/imgs/icon_hot_new.png" alt="" />
                  <div class="section-list-item-content">
                    <h4>{{$t('smart-venues-section-3-item-5-title')}}</h4>
                    <p>{{$t('smart-venues-section-3-item-5-content')}}</p>
                  </div>
                </b-col>

                <b-col cols="6" class="section-list-item">
                  <img class="section-list-item-img" src="../assets/imgs/icon_vedio.png" alt="" />
                  <div class="section-list-item-content">
                    <h4>{{$t('smart-venues-section-3-item-6-title')}}</h4>
                    <p>{{$t('smart-venues-section-3-item-6-content')}}</p>
                  </div>
                </b-col>

              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">手机降温加速器</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_a_1.png"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_a_2.png"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_a_3.png"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/des_a_4.png"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    手机一键真降温，超强极速的空间清理加速神器！
                    <br/>
                    用更少的时间，安全彻底删除更多无用的文件，致力于为用户提供更安全更快捷的清理体验！
                    <br/>
                    一手机降温一
                    <br/>
                    【电池省电】一键智能省电，智能监测手机温度，电量，电压，健康状态动态监测
                    <br/>
                    【CPU降温】一键真降温，不再为手机发烫烦恼，手机的降温管家
                    <br/>
                    一极速清理一
                    <br/>
                    【一键清理】一键搞定无用垃圾，手机清理更省心
                    <br/>
                    【深度清理】全盘扫描手机储存空间，深度清理垃圾
                    <br/>
                    【手机加速】瞬间释放手机内存，加速效果超同行
                    <br/>
                    【抖音|QQ|微信清理】有效清理抖音，微信，qq的无用垃圾文件，让手机运行更顺畅
                    <br/>
                    一手机管理一
                    <br/>
                    【通知清理】告别无用的推送通知！
                    <br/>
                    【最近文件】视频、照片、音频、安装包等文件一键管理，智能识别可删文件</h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <section class="page-section">
        <h1 class="section-title">朝夕美颜P图</h1>
        <b-container>
          <b-row>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/psd_des_1.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/psd_des_2.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/psd_des_3.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="3" xl="3" class="text-center">
              <b-img class="section-head-img" fluid src="../assets/imgs/psd_des_4.jpg"></b-img>
            </b-col>
            <b-col sm="12" md="12" xl="12">
              <b-row>
                <div class="section-list-item-content">
                  <p>
                    <br/>
                  </p>
                  <h6>
                    美颜P图包含美颜相机修图，潮自拍，编辑P图，动态贴纸，是一款免费美颜自拍、照片编辑、相片编辑、相机应用程序，包含各种拍照模式、照片滤镜和效果、美颜滤镜、相机贴纸，美易图片编辑器，美图照片拼接编辑
                    <br/>
                    美颜P图功能:
                    <br/>
                    【美颜滤镜】高级质感滤镜实时更新，主流滤镜模式调整，美爆朋友圈
                    <br/>
                    【美图贴纸】动态贴图、视频贴图，美拍、美妆、美颜都能用上，实时预览动画效果
                    <br/>
                    【全能修图】编辑、边框、贴纸、画笔.….超多美化功能，给您想要的范儿，补光、动感、提升魅力
                    <br/>
                    【动态相机】动态贴纸、音乐相机，提升你的萌属性，秒变精致小仙女
                  </h6>
                </div>
              </b-row>
            </b-col>
          </b-row>
        </b-container>
        <br/>
        <a href="http://www.chuangzhihe.com/czh/apk/question.apk" class="btn" target="view_window">立即下载体验</a>
      </section>
      <!--      <section class="page-section">-->
<!--        <h1 class="section-title">{{$t('smart-venues-section-4-title')}}</h1>-->
<!--        <b-container>-->
<!--          <b-row>-->
<!--            <b-col sm="12" md="4" xl="4" class="text-center">-->
<!--              <b-img class="section-head-img" fluid src="../assets/imgs/bg_lebu.jpg"></b-img>-->
<!--            </b-col>-->
<!--            <b-col sm="12" md="8" xl="8">-->
<!--              <b-row>-->
<!--                <b-col cols="6" class="section-list-item">-->
<!--                  <img class="section-list-item-img" src="../assets/imgs/icon_jibu.png" alt="" />-->
<!--                  <div class="section-list-item-content">-->
<!--                    <h4>{{$t('smart-venues-section-4-item-1-title')}}</h4>-->
<!--                    <p>{{$t('smart-venues-section-4-item-1-content')}}</p>-->
<!--                  </div>-->
<!--                </b-col>-->

<!--                <b-col cols="6" class="section-list-item">-->
<!--                  <img class="section-list-item-img" src="../assets/imgs/icon-chart.png" alt="" />-->
<!--                  <div class="section-list-item-content">-->
<!--                    <h4>{{$t('smart-venues-section-4-item-2-title')}}</h4>-->
<!--                    <p>{{$t('smart-venues-section-4-item-2-content')}}</p>-->
<!--                  </div>-->
<!--                </b-col>-->

<!--                <b-col cols="6" class="section-list-item">-->
<!--                  <img class="section-list-item-img" src="../assets/imgs/icon-locate-target.png" alt="" />-->
<!--                  <div class="section-list-item-content">-->
<!--                    <h4>{{$t('smart-venues-section-4-item-3-title')}}</h4>-->
<!--                    <p>{{$t('smart-venues-section-4-item-3-content')}}</p>-->
<!--                  </div>-->
<!--                </b-col>-->

<!--                <b-col cols="6" class="section-list-item">-->
<!--                  <img class="section-list-item-img" src="../assets/imgs/icon_route.png" alt="" />-->
<!--                  <div class="section-list-item-content">-->
<!--                    <h4>{{$t('smart-venues-section-4-item-4-title')}}</h4>-->
<!--                    <p>{{$t('smart-venues-section-4-item-4-content')}}</p>-->
<!--                  </div>-->
<!--                </b-col>-->

<!--                <b-col cols="6" class="section-list-item">-->
<!--                  <img class="section-list-item-img" src="../assets/imgs/icon_paihangbang.png" alt="" />-->
<!--                  <div class="section-list-item-content">-->
<!--                    <h4>{{$t('smart-venues-section-4-item-5-title')}}</h4>-->
<!--                    <p>{{$t('smart-venues-section-4-item-5-content')}}</p>-->
<!--                  </div>-->
<!--                </b-col>-->

<!--                <b-col cols="6" class="section-list-item">-->
<!--                  <img class="section-list-item-img" src="../assets/imgs/icon_liek.png" alt="" />-->
<!--                  <div class="section-list-item-content">-->
<!--                    <h4>{{$t('smart-venues-section-4-item-6-title')}}</h4>-->
<!--                    <p>{{$t('smart-venues-section-4-item-6-content')}}</p>-->
<!--                  </div>-->
<!--                </b-col>-->

<!--              </b-row>-->
<!--            </b-col>-->
<!--          </b-row>-->
<!--        </b-container>-->
<!--      </section>-->

    </b-container>
  </div>
</template>

<script>

import HeaderStyles1 from '../components/HeaderStyles3.vue'
export default {
  name: 'SmartVenues',
  components: {
    HeaderStyles1
  },
  data () {
    return {

    }
  },
  mounted () {
    document.title = '产品专区'
  }
}
</script>

<style scoped lang="scss">
  .smart-venues {
    overflow-x: hidden;
    .platform-title-img {
      max-width: 50%;
      bottom: 30px;
    }

    .page-section {
      margin-top: 90px;
      margin-bottom: 90px;

      .section-title {
        font-size: 34px;
        font-weight: 700;
        color: #000000;
        margin-bottom: 60px;
      }
    }

    .btn {
      padding: 12px 58px;
      font-size: 18px;
      font-weight: 600;
      border: 1px solid #333333;
      border-radius: 28px;
      color: #333333;
      outline: 0 none;
      text-transform: capitalize;
      transition: .3s;
      -webkit-border-radius: 28px;
      -moz-border-radius: 28px;
      -ms-border-radius: 28px;
      -o-border-radius: 28px;
    }
    .btn:hover{color: #333333;background: #ffffff;}
    .btn:focus{color: #333333;background: #ffffff;}
    .section-1-content {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;
    }
    .section-1-title {
      font-size: 24px;
      font-weight: 700;
      color: #39239e;
    }
    .section-1-item {
      width: 200px;
      height: 230px;
      border-radius: 4px;
      background: #6c63ff;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      color: #ffffff;
      font-size: 24px;
      font-weight: bold;
      text-align: center;
      img {
        margin-bottom: 20px;
        width: 36px;
      }
    }
    .section-1-arrow {
      display: inline-flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      > span {
        font-size: 16px;
        margin-top: 20px;
        color: #39239E;
        font-weight: bold;
      }
    }
    .arrow-top-wrap {
      .arrow-top {
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 0 64px 30px 64px;
        border-color: transparent transparent #39239e transparent;
      }
    }

    .section-2-text {
      padding: 20px;
      font-size: 22px;
      font-weight: bold;
      line-height: 1.4;
      color: #ffffff;
      background-color: #6C63FF;
    }

    .section-head-img {
      width: 200px;
    }
    .section-list-item {
      display: inline-flex;
      padding: 20px;

      .section-list-item-img {
        height: 60px;
        width: 60px;
        object-fit: contain;
        align-self: flex-start;
        margin-right: 20px;
      }
      .section-list-item-content {
        flex: 1;
        display: flex;
        flex-direction: column;

        h4 {
          font-size: 16px;
          font-weight: bold;
          line-height: 1.5;
        }
        p {
          font-size: 16px;
          line-height: 1.4;
        }
      }
    }
  }
</style>
<style scoped lang="scss">
  @media (max-width: 768px) {
    .smart-venues {
      .page-section {

        .section-title {
          font-size: 18px;
          text-align: center;
          margin-bottom: 30px;
        }

        .section-1-title {
          font-size: 14px;
        }
        .arrow-top-wrap {
          transform: translateY(-25px);
          .arrow-top {
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 0 19.5px 9px 19.5px;
            border-color: transparent transparent #39239e transparent;
          }
        }
        .section-1-content {
          margin-top: 0;
        }

        .section-1-item {
          height: 90px;
          img {
            width: 12px;
            margin-bottom: 10px;
          }
          span {
            font-size: 10px;
            transform: scale(0.8);
            height: 30px;
          }
        }
        .section-1-arrow {
          padding: 0;

          span {
            font-size: 10px;
            transform: scale(0.5);
          }
        }

        .section-2-text {
          padding: 15px;
          font-size: 16px;
        }
      }

      .section-head-img {
        margin-bottom: 20px;
        width: 90px;
      }
      .section-list-item {
        padding: 10px;

        .section-list-item-img {
          height: 30px;
          width: 30px;
          margin-right: 10px;
        }
        .section-list-item-content {
          h4 {
            font-size: 12px;
          }
          p {
            font-size: 12px;
          }
        }
      }
    }
  }
</style>
